import { Formik } from 'formik';
import React, { FC } from 'react';
import FormResponseMessage from '../forms/formResponseMessage';
import { deliverytimeInitialValues, deliverytimeSchema } from './deliverytime.schema';
import * as StyledDeliverytime from './deliverytime.styles';
import DeliverytimeFormFields from './deliverytimeFormFields';

interface Props {}

const Deliverytime: FC<Props> = () => {
	return (
		<StyledDeliverytime.Wrapper>
			<Formik
				initialValues={deliverytimeInitialValues}
				enableReinitialize
				validationSchema={deliverytimeSchema}
				onSubmit={()=>{}}>
				{({ values, handleSubmit, setFieldTouched, setFieldValue, isSubmitting, status, touched, errors }) => (
					<form onSubmit={handleSubmit}>
						{!status && (
							<DeliverytimeFormFields
								values={values}
								setFieldTouched={setFieldTouched}
								setFieldValue={setFieldValue}
								isSubmitting={isSubmitting}
								touched={touched}
								errors={errors}
							/>
						)}
						<FormResponseMessage status={status} />
					</form>
				)}
			</Formik>
		</StyledDeliverytime.Wrapper>
	);
};

export default Deliverytime;
